module.exports = __webpack_public_path__ + "static/media/Saleem Kainikkara - CEO.2f1215b5.jpg";